<template>
  <div v-if="show">
    <b-table
      responsive
      :stacked="stacked"
      class="mb-0 table-drugs"
      :items="items"
      :fields="items_fields"
      :busy.sync="isBusy"
      head-variant="gray"
    >
      <template v-slot:cell(dirty)="data" v-if="dirtycolumn">
        <div v-show="data.item.isdirty">
          <font-awesome-icon
            v-b-tooltip.hover
            class="mr-2"
            icon="exclamation-triangle"
            :title="$t('drugs_summary.not_saved')"
          />
          <span class="d-sm-none">{{ $t("drugs_summary.not_saved") }}</span>
        </div>
        <div v-show="!data.item.isdirty">
          <font-awesome-icon
            v-b-tooltip.hover
            class="mr-2"
            icon="check-circle"
            :title="$t('drugs_summary.is_saved')"
          />
          <span class="d-sm-none">{{ $t("drugs_summary.is_saved") }}</span>
        </div>
      </template>

      <template v-slot:cell(picture)="data" v-if="picturecolumn">
        <b-img
          :src="
            data.item.picture && data.item.picture.picture
              ? data.item.picture.picture
              : fallback
          "
          fluid-grow
          @error="imageLoadError"
        />
      </template>

      <template slot="state">
        <span class="state px-4 py-1">{{ $t("drugs_summary.stock") }}</span>
      </template>

      <!-- <tempv-slot:cell(lot)="data"scope="data">
        <div>{{$t('drugs_summary.short_expiry_date')}}: {{data.item.expiry_date}}</div>
        <div>{{$t('drugs_summary.short_batch')}}: {{data.item.batch}}</div>
      </template>-->

      <template v-slot:cell(unit_price)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        {{
          formatPrice(
            Number(data.item.price.no_tax_price) +
              Number(data.item.price.discounted),
            data.item.price.no_tax_price_currency
          )
        }}
      </template>


      <template v-slot:cell(description)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        <div v-if="data.item.parent">
          <span @click="$router.push({name: 'product_sheet', params: {drugUuid: data.item.parent}})">
            {{ data.item.description }}
          </span>
        </div>
        <div v-else>{{ data.item.description }}</div>
        {{
          formatPrice(
            Number(data.item.price.no_tax_price) +
              Number(data.item.price.discounted),
            data.item.price.no_tax_price_currency
          )
        }}
      </template>

      <template v-slot:cell(tax)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        {{
          formatPrice(
            data.item.price.all_included_price - data.item.price.no_tax_price,
            data.item.price.all_included_price_currency
          )
        }}
      </template>

      <template v-slot:cell(total)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        {{
          formatPrice(
            data.item.price.all_included_price,
            data.item.price.all_included_price_currency
          )
        }}
      </template>

      <template v-slot:cell(discounted_price)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        <div
          v-if="
            data.item.price.discounts && data.item.price.discounts.length > 0
          "
        >
          <div
            v-for="(discount, index) in data.item.price.discounts"
            :key="index"
          >
            {{ $t("drugs_summary.discount") }}
            <b-badge variant="warning">
              {{ Number(discount.percent_value) }}%
            </b-badge>
          </div>
          {{
            formatPrice(
              data.item.price.no_tax_price,
              data.item.price.no_tax_price_currency
            )
          }}
        </div>
      </template>

      <template v-slot:cell(quantity)="data">
        <vue-element-loading
          :active="isBusy && data.item.uuid == busyItemUuid"
        />
        <div class="d-flex justify-content-center" v-if="quantityinput">
          <NumericInput
            :min="1"
            align="center"
            size="100%"
            :value="data.item.quantity"
            @input="newValue => modifyQuantity(data.item, newValue)"
          />
        </div>
        <div v-else>
          {{ data.item.quantity }}
          <span v-if="isPack(data.item)">
            x {{ packQuantity(data.item) }}
          </span>
        </div>
      </template>

      <template v-slot:cell(actions)="data" v-if="actionscolumn">
        <b-link
          @click="onDeleteButtonClick(data.item)"
          class="table-link-action icon-link-primary"
        >
          <font-awesome-icon :icon="['far', 'times-circle']" />
        </b-link>
      </template>
    </b-table>

    <!-- cuidado, esto se usa en la sección de importación de productos -->
    <b-button
      v-if="adddrugbutton"
      type="button"
      class="w-100 mt-4 mt-sm-0 pb-3 pt-3 font-weight-semibold add-button"
      @click="onDrugsButtonClick()"
    >
      <VPlusCircleIcon class="plusicon" :size="28" />
      {{ $t("drugs_summary.add_drug_button") }}
    </b-button>

    <b-container fluid class="px-0 mx-0 mt-5" v-if="showamount">
      <vue-element-loading :active="isBusy" />
      <b-row no-gutters>
        <b-col
          cols="12"
          xs="12"
          :lg="
            amount_deductible != '0' || amount_coinsurance != '0' ? '6' : '4'
          "
          :offset-lg="
            amount_deductible != '0' || amount_coinsurance != '0' ? '6' : '8'
          "
          class="summary-column pr-0"
        >
          <b-container fluid class="mr-0 pr-0">
            <b-row no-gutters>
              <b-col
                v-if="amount_deductible != '0' || amount_coinsurance != '0'"
                cols="12"
                xs="12"
                lg="6"
              >
                <table
                  class="table b-table table-summary table-striped table-hover mr-0 pr-0 selectable"
                >
                  <tr v-if="amount_deductible != '0'">
                    <td>{{ $t("drugs_summary.deductible") }}</td>
                    <td class="text-right">{{ amount_deductible }}</td>
                  </tr>
                  <tr v-if="amount_coinsurance != '0'">
                    <td>{{ $t("drugs_summary.coinsurance") }}</td>
                    <td class="text-right">{{ amount_coinsurance }}</td>
                  </tr>
                  <tr
                    class="total-row"
                    v-if="computed_amount.provider_total > 0"
                  >
                    <td>{{ $t("drugs_summary.patient_total") }}</td>
                    <td class="text-right">
                      {{ computed_amount.buyer_total.toLocaleString() }}
                    </td>
                  </tr>
                </table>
              </b-col>
              <b-col
                cols="12"
                xs="12"
                :lg="
                  amount_deductible != '0' || amount_coinsurance != '0'
                    ? '6'
                    : '12'
                "
              >
                <TotalAmountSummary
                  :showAll="false"
                  :amount="computed_amount"
                  :items="items"
                  showSubtotal
                  showTaxes
                  showDiscount
                  showTotal
                  striped
                  :showOfferCode="offercodeinput"
                  class="py-5"
                />
                <div v-if="priceswarning" class="prices_warning text-center">
                  {{ $t("drugs_summary.prices_warning") }}
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  AMOUNT_TYPE_SUBTOTAL,
  // AMOUNT_TYPE_SUBTOTAL_TAX,
  AMOUNT_TYPE_DEDUCTIBLE,
  AMOUNT_TYPE_COINSURANCE,
  // AMOUNT_TYPE_DISCOUNT,
  // AMOUNT_TYPE_HANDLING_FEE,
  AMOUNT_TYPE_SHIPPING,
  // AMOUNT_TYPE_SHIPPING_DISCOUNT,
  // AMOUNT_TYPE_CUSTOM_FEE,
  // COINSURANCE_TYPE_PERCENT,
  // COINSURANCE_TYPE_STATIC,
} from "@/lib/amount.js";
import debounce from "lodash/debounce";
// import { Money } from "@/lib/money.js";
import { buildAmount } from "@/lib/amount.js";
import { isDrugsPack, getPackQuantity } from "@/lib/drugs.js";

import NumericInput from "@/components/NumericInput";
import VPlusCircleIcon from "@/components/VPlusCircleIcon";
import TotalAmountSummary from "@/components/TotalAmountSummary";

export default {
  name: "v-drugs-summary",
  props: {
    items: {
      default: undefined,
      type: [Array, Object, Function],
    },
    // TODO: obsoleto
    summary: {
      default: undefined,
      type: Object,
    },
    busyItemUuid: {
      default: undefined,
      type: String,
    },
    dirtycolumn: {
      default: false,
      type: Boolean,
    },
    statecolumn: {
      default: false,
      type: Boolean,
    },
    quantityinput: {
      default: false,
      type: Boolean,
    },
    picturecolumn: {
      default: false,
      type: Boolean,
    },
    taxcolumn: {
      default: false,
      type: Boolean,
    },
    totalcolumn: {
      default: false,
      type: Boolean,
    },
    actionscolumn: {
      default: false,
      type: Boolean,
    },
    adddrugbutton: {
      default: false,
      type: Boolean,
    },
    isBusy: {
      default: false,
      type: Boolean,
    },
    // amount para ser utilizado en los summaries a mostrar
    amount: {
      default: undefined,
      type: Object,
    },
    // amount para ser utilizado en el total
    raw_amount: {
      default: undefined,
      type: Object,
    },
    showamount: {
      default: true,
      type: Boolean,
    },
    stacked: {
      default: "sm",
      type: String,
    },
    offercodeinput: {
      default: false,
      type: Boolean,
    },
    priceswarning: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      show: true,
      fallback: require("@/static/fallback_drug_picture.png"),
      preferred_currency: undefined,
    };
  },
  computed: {
    items_fields() {
      return [
        {
          key: "dirty",
          label: "",
          class: this.dirtycolumn ? "selectable align-middle" : "d-none",
          thClass: this.dirtycolumn ? "unselectable align-middle" : "d-none",
        },
        {
          key: "picture",
          label: this.$t("drugs_summary.headtable_product"),
          class: this.picturecolumn
            ? "unselectable align-middle reduced-col"
            : "d-none",
          thClass: this.picturecolumn
            ? "unselectable align-middle reduced-col text-center text-uppercase"
            : "d-none",
        },
        // {
        //   key: "ean",
        //   label: this.$t("drugs_summary.headtable_ean"),
        //   class: "selectable",
        //   thClass: "unselectable align-middle"
        // },
        {
          key: "description",
          label: this.$t("drugs_summary.headtable_drug_name"),
          class: "selectable align-middle",
          thClass: "unselectable align-middle text-uppercase",
        },
        {
          key: "state",
          label: this.$t("drugs_summary.headtable_state"),
          class: this.statecolumn ? "selectable align-middle" : "d-none",
          thClass: this.statecolumn
            ? "unselectable align-middle text-uppercase"
            : "d-none",
        },
        // {
        //   key: "batch_expire",
        //   label: this.$t("drugs_summary.headtable_batch_expire"),
        //   class: "selectable",
        //   thClass: "unselectable align-middle"
        // },
        {
          key: "unit_price",
          label: this.$t("drugs_summary.headtable_unit_price"),
          class: "selectable align-middle",
          thClass: "unselectable align-middle text-uppercase",
        },
        {
          key: "discounted_price",
          label: this.$t("drugs_summary.headtable_discounted_price"),
          class: "selectable align-middle",
          thClass: "unselectable align-middle text-uppercase",
        },
        {
          key: "quantity",
          label: this.$t("drugs_summary.headtable_quantity"),
          class: "selectable reduced-col align-middle",
          thClass: "unselectable reduced-col align-middle text-uppercase",
        },
        {
          key: "tax",
          label: this.$t("drugs_summary.headtable_tax"),
          class: this.taxcolumn
            ? "selectable reduced-col align-middle"
            : "d-none",
          thClass: this.taxcolumn
            ? "unselectable reduced-col align-middle text-uppercase"
            : "d-none",
        },
        {
          key: "total",
          label: this.$t("drugs_summary.headtable_total"),
          class: this.totalcolumn
            ? "selectable reduced-col align-middle"
            : "d-none",
          thClass: this.taxcolumn
            ? "unselectable reduced-col align-middle text-uppercase"
            : "d-none",
        },
        {
          key: "actions",
          label: "",
          class: this.actionscolumn
            ? "unselectable align-middle text-center"
            : "d-none",
          thClass: this.actionscolumn ? "unselectable align-middle" : "d-none",
        },
      ];
    },
    // TODO: obsoleto
    internal_summary: function () {
      var subtotal = 0;
      var taxes = 0;
      var total = 0;
      var currency = "XXX";
      this.items.forEach((element) => {
        total += element.price.all_included_price * element.quantity;
        subtotal += element.price.no_tax_price * element.quantity;
        taxes += element.price.all_included_price - element.price.no_tax_price;
        currency = element.price.base_currency;
      });
      return {
        subtotal: subtotal,
        taxes: taxes,
        total: total,
        currency: currency,
      };
    },
    item_currencies: function () {
      var currencies = [];
      this.items.forEach((element) => {
        if (currencies.indexOf(element.price.base_currency) < 0) {
          currencies.push(element.price.base_currency);
        }
      });
      return currencies;
    },
    computed_amount: function () {
      if (this.amount) {
        return this.amount;
      }
      var preferred_currency = this.preferred_currency;
      if (this.item_currencies && this.item_currencies.length == 1) {
        preferred_currency = this.item_currencies[0];
      }
      let _amount = buildAmount(this.items, preferred_currency);
      return _amount;
    },
    amount_deductible: function () {
      if (!this.computed_amount) {
        return "0";
      }
      if (!this.computed_amount.details) {
        return "0";
      }

      let detail = this.computed_amount.getDetailByType(AMOUNT_TYPE_DEDUCTIBLE);
      if (!detail || detail.amount == 0) {
        return "0";
      }
      return detail.toLocaleString();
    },
    amount_coinsurance: function () {
      if (!this.computed_amount) {
        return "0";
      }
      if (!this.computed_amount.details) {
        return "0";
      }

      let detail = this.computed_amount.getDetailByType(
        AMOUNT_TYPE_COINSURANCE
      );
      if (!detail || detail.amount == 0) {
        return "0";
      }
      return detail.toLocaleString();
    },
    amount_subtotals: function () {
      if (!this.computed_amount) {
        return "0";
      }
      if (!this.computed_amount.details) {
        return "0";
      }
      // Aquí devolvemos un array, ojo con eso
      return this.computed_amount.getAllDetailByType(AMOUNT_TYPE_SUBTOTAL);
    },
    amount_subtotal_shipping: function () {
      if (!this.computed_amount) {
        return "0";
      }
      if (!this.computed_amount.details) {
        return "0";
      }

      let detail = this.computed_amount.getDetailByType(AMOUNT_TYPE_SHIPPING);
      if (!detail) {
        return "0";
      }
      return detail.toLocaleString();
    },
    amount_subtotal_taxs: function () {
      if (!this.computed_amount) {
        return "0";
      }
      if (
        !this.computed_amount._subtotals ||
        !this.computed_amount._subtotals.subtotals_tax
      ) {
        return "0";
      }
      return this.computed_amount._subtotals.subtotals_tax;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        drugs_summary: {
          headtable_ean: "Ean",
          headtable_drug_name: "Drug name",
          headtable_quantity: "Quantity",
          headtable_total: "Total",
          headtable_batch_expire: "Batch/Expiry date",
          headtable_unit_price: "Unit price",
          headtable_product: "Product",
          headtable_state: "State",
          headtable_tax: "Tax",
          headtable_discounted_price: "Discounted price",
          subtotal: "Subtotal",
          taxes: "Taxes",
          discounts: "Discounts",
          discount: "Discount",
          shipping: "Shipping",
          total: "Total",
          is_saved: "This product is saved",
          not_saved: "This product is not saved yet!",
          short_expiry_date: "ED",
          short_batch: "B",
          deductible: "Deductible",
          coinsurance: "Coinsurance",
          patient_total: "Patient total",
          insurance_total: "Insurance total",
          add_drug_button: "Add new drug",
          apply: "Apply",
          offer_code: "Offer code",
          prices_warning: "* Prices depend on the payment method",
          stock: "Stock",
        },
      },
    },
  },
  // mounted: function () {
  // },
  methods: {
    handleTotalClick() {
      this.$emit("summary:currency_switch");
    },
    formatPrice(raw, currency) {
      return this.$formatMoney(raw, currency);
      // return new Money(raw, currency).toLocaleString();
    },
    onDeleteButtonClick(item) {
      this.$emit("deleteButtonClick", item);
    },
    onDrugsButtonClick() {
      this.$emit("drugsButtonClick");
    },
    modifyQuantity: debounce(function (item, newValue) {
      const number = Number.parseInt(newValue);
      if (!Number.isNaN(number)) {
        this.$emit("modifyQuantity", item, number);
      }
    }, 500),
    // modifyQuantity(item, newValue) {
    //   const number = Number.parseInt(newValue);
    //   if (!Number.isNaN(number)) {
    //     this.$emit("modifyQuantity", item, newValue);
    //   }
    // },
    imageLoadError(evt) {
      evt.srcElement.src = require("@/static/fallback_drug_picture.png");
    },
    isPack(item) {
      return isDrugsPack(item);
    },
    packQuantity(item) {
      return getPackQuantity(item);
    },
  },
  components: {
    NumericInput,
    VPlusCircleIcon,
    TotalAmountSummary,
  },
};
</script>

<style lang="scss" scoped>
@include media-breakpoint-down(sm) {
  ::v-deep .table-drugs {
    tr > td:first-of-type {
      grid-template-columns: 100% !important;
      text-align: center;
    }
  }
}

::v-deep .table-drugs {
  th {
    border-bottom: 1px solid $text-fourth-color;
    border-top: none;
  }

  tr:last-of-type {
    border-bottom: 1px solid $table-gray-border-color;
  }

  .reduced-col {
    width: 10%;

    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }
}

.add-button {
  background-color: $gray-100 !important;
  color: black !important;
  border-color: $table-gray-border-color !important;
  border-radius: 0 !important;
  display: block !important;
  font-size: $font-size-default * 1.01 !important;

  span {
    font-size: 1rem;
    margin: initial !important;
    padding: 0 !important;
  }
  @include media-breakpoint-up(sm) {
    border-top: 0;
  }
}

.table-summary {
  background-color: $table-summary-bg-color;

  .total-row {
    background-color: $table-summary-total-bg-color;
    cursor: pointer;

    td {
      font-weight: bold !important;
    }
  }

  tr:last-of-type {
    border-bottom: 1px solid $table-gray-border-color;
  }
}

.state {
  background-color: $corp-color2;
  border: 1px solid $corp-color2;
  border-radius: 0.3rem;
  color: white;
}

.prices_warning {
  color: $text-fourth-color;
  font-size: $font-size-small;
}
</style>
